import * as React from "react";
import {Field} from "react-final-form";

export default class FuenteEstadoPoliza extends React.Component<FuenteEstadoPolizaProps> {
    render() {
        const {className} = this.props;
        const {fuenteEstadoPoliza} = this.props;
        return (
            <Field name={this.props.name}>
                {({input, meta}) => (
                    <div>
                        <select {...input} className={className ? className.concat(" form-control") : "form-control"}>
                            <option value={""}>Selecciona...</option>
                            {fuenteEstadoPoliza.map(solicitud => {
                                return <option key={solicitud.tipo} value={solicitud.tipo}>{solicitud.nombre}</option>;
                            })}
                        </select>
                        <div>
                            {meta.error && <span className={"text-danger"}>{meta.error}</span>}
                        </div>
                    </div>
                )}
            </Field>
        );
    }

}

interface FuenteEstadoPolizaProps {
    name: string,
    fuenteEstadoPoliza: any
    className?: string
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/inconsistencias/componentes/FuenteEstadoPoliza.tsx